import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

const settings = {
	title: 'settings',
	components: [
		{
			title: 'eco_mode',
			component: 'eco_mode_g2',
		},
		{
			title: 'device_name',
			component: 'device_name_g2',
		},
		{
			title: 'operational_counters',
			component: 'operational_counters_g2',
			requires_operational_counters: true,
		},
		{
			title: 'firmware_version',
			component: 'firmware_update',
		},
		{
			title: 'geo_location_and_time_zone',
			component: 'location_g2',
		},
		{
			title: 'device_reboot',
			component: 'device_reboot',
		},
		{
			title: 'factory_reset',
			component: 'factory_reset',
		},
		{
			title: 'device_information',
			component: 'device_information',
		},
	],
};

export default {
	name: 'PowerTrack500',
	friendly_name: 'Power Track 500',
	family: 'power_meter',
	isPM: true,
	modes: {
		power_meter: {
			channels: 1,
			notifications: ['offline', 'device_problem', 'overpower', 'overvoltage', 'overtemperature'],
			settings: [
				schedule_gen_2,
				webhooks_gen_2,
				scripts_gen_2,
				networks_gen_2_plus,
				bluetooth_gen_2,
				{
					title: 'application_settings',
					components: [
						{
							title: 'device_card_customization',
							component: 'customize_device_content',
						},
						{
							title: 'exclude_event_log',
							component: 'exclude_event_log',
						},
					],
				},
				share,
				settings,
			],
		},
	},
};
